import classNames from "classnames";

export default function TicketStatusLabel({ status = null, size = "small" }) {
  let statusLabel = null;

  const baseClass = "px-5 py-2 rounded-full font-medium leading-none";
  const orangeStyleClass = "bg-orange-100/50 text-orange-300";
  const violetStyleClass = "bg-violet-600/20 text-violet-600";
  const smallFontClass = "text-[10px]";
  const mediumFontClass = "text-xs";

  if (status === "OPEN") {
    statusLabel = (
      <div
        className={classNames(
          baseClass,
          orangeStyleClass,
          size === "small" ? smallFontClass : mediumFontClass
        )}
      >
        Pending
      </div>
    );
  } else if (status === "CLOSED") {
    statusLabel = (
      <div
        className={classNames(
          baseClass,
          violetStyleClass,
          size === "small" ? smallFontClass : mediumFontClass
        )}
      >
        Closed
      </div>
    );
  } else if (status === "RESOLVED") {
    statusLabel = (
      <div
        className={classNames(
          baseClass,
          violetStyleClass,
          size === "small" ? smallFontClass : mediumFontClass
        )}
      >
        Resolved
      </div>
    );
  }

  return statusLabel;
}
